import { cn } from '@v2/shared/lib/utils';
import { Popover } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import NamedIcon from '@v2/shared/components/NamedIcon';
import { Category } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  category: Category;
};

export default function CategoryLink({ category }: Props) {
  const { buildUrl } = useUrlGenerator();

  return (
    <Popover.Button
      as="a"
      href={buildUrl(category.href)}
      className={cn(
        'group',
        'py-2 px-3 rounded-md text-sm cursor-pointer',
        'flex w-full items-center justify-between',
        'hover:bg-slate-100 active:bg-red-100 active:text-red-900'
      )}
    >
      <span className="flex items-center">
        <NamedIcon
          name={category.icon}
          prefix="fas"
          fixedWidth
          className={cn('mr-2', 'group-active:text-red-900', { 'text-slate-900': !!category.icon })}
        />
        <div className={cn('font-medium text-slate-900 group-active:text-red-900 truncate w-[200px]', {})}>
          {category.name}
        </div>
      </span>
      <FontAwesomeIcon
        icon={faAngleRight}
        fixedWidth
        size="lg"
        className={cn('text-slate-400 group-active:text-red-900')}
      />
    </Popover.Button>
  );
}
